var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useContext } from "react";
import { useAccountLogout, useShowOneLoginDialog } from "../AccountProvider";
import { isSKLand } from "../helper";
import { RoleContext } from "./context";
import { clearRoleMeta, getRoleMeta, setRoleMeta } from "./utils";
export function useRole() {
    var _a = useContext(RoleContext).store, role = _a.role, loading = _a.loading;
    return { role: role, loading: loading };
}
export function useRoleMeta() {
    var _a = useContext(RoleContext), site = _a.site, ready = _a.store.ready;
    if (!ready) {
        console.warn("[@hg/one-account] useRoleMeta too early, context wasn't ready.");
        return null;
    }
    return getRoleMeta({ site: site });
}
/**
 * 角色登出
 *
 * @export
 */
export function useRoleLogout() {
    var _this = this;
    var _a = useContext(RoleContext), dispatch = _a.dispatch, site = _a.site;
    var accountLogout = useAccountLogout();
    return useCallback(function (option) { return __awaiter(_this, void 0, void 0, function () {
        var _a, withAccount, roleMeta;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isSKLand()) {
                        console.warn("[@hg/one-account] Only switch role in skland.");
                        return [2 /*return*/];
                    }
                    _a = (option || {}).withAccount, withAccount = _a === void 0 ? true : _a;
                    roleMeta = getRoleMeta({ site: site });
                    if (!roleMeta)
                        return [2 /*return*/];
                    if (!(roleMeta.channel === "account" && withAccount)) return [3 /*break*/, 2];
                    return [4 /*yield*/, accountLogout()];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    clearRoleMeta({ site: site });
                    dispatch({ role: null, isAccount: null });
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, { site: site }]);
}
export function useShowChannelSelect() {
    var _this = this;
    var _a = useContext(RoleContext), dispatch = _a.dispatch, sdkReady = _a.sdkReady, skipChannelSelect = _a.skipChannelSelect, channelConfigList = _a.channelConfigList, disableAccount = _a.disableAccount, customChannelSelect = _a.customChannelSelect;
    var showAccountLogin = useShowOneLoginDialog();
    return useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isSKLand()) {
                console.warn("[@hg/one-account] Only switch role in skland.");
                return [2 /*return*/];
            }
            if (customChannelSelect)
                return [2 /*return*/];
            if (channelConfigList.length === 0) {
                if (disableAccount) {
                    return [2 /*return*/, console.warn("[@hg/one-account] No channel enabled.")];
                }
                if (skipChannelSelect) {
                    showAccountLogin();
                    return [2 /*return*/];
                }
            }
            dispatch({
                channelSelectVisible: true,
            });
            return [2 /*return*/];
        });
    }); }, [
        sdkReady,
        customChannelSelect,
        skipChannelSelect,
        disableAccount,
        channelConfigList,
        dispatch,
    ]);
}
export function useShowRoleSelect() {
    var _this = this;
    var _a = useContext(RoleContext), sdkReady = _a.sdkReady, disableAccount = _a.disableAccount, gameCode = _a.gameCode, site = _a.site, disableAccountRoleSelect = _a.disableAccountRoleSelect, fetchRoleInfo = _a.fetchRoleInfo, onSelectRole = _a.onSelectRole, dispatch = _a.dispatch, _b = _a.store, isAccount = _b.isAccount, role = _b.role;
    var useClientRoleInfo = !fetchRoleInfo;
    function verifyRoleWithServer(token) {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, verifier, roleInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!fetchRoleInfo)
                            return [2 /*return*/];
                        return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _a.sent();
                        return [4 /*yield*/, sdk.Account.API.getToken()
                            // 先设置 roleMeta 到 store 中
                            // 原因：fetchRoleInfo 的实现可能使用 createRequest 出来的httpClient
                        ];
                    case 2:
                        verifier = _a.sent();
                        // 先设置 roleMeta 到 store 中
                        // 原因：fetchRoleInfo 的实现可能使用 createRequest 出来的httpClient
                        setRoleMeta({ token: token, channel: "account", verifier: verifier || "" }, { site: site });
                        return [4 /*yield*/, fetchRoleInfo(token)
                            // 如果不能正常返回，表示角色会话不一致
                        ];
                    case 3:
                        roleInfo = _a.sent();
                        // 如果不能正常返回，表示角色会话不一致
                        if (!roleInfo)
                            clearRoleMeta({ site: site });
                        return [2 /*return*/, dispatch({
                                role: roleInfo,
                            })];
                }
            });
        });
    }
    return useCallback(function (onError) { return __awaiter(_this, void 0, void 0, function () {
        var sdk;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disableAccount || disableAccountRoleSelect) {
                        console.warn("[@hg/one-account] Can't open role select with current `RoleProvide` props.");
                        // onError(new Error("Not support"))
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    if (sdk.SDK_TYPE === "HG") {
                        sdk.Role.UI.showSelectDialog(gameCode, {
                            defaultActiveUid: (role === null || role === void 0 ? void 0 : role.uid) || undefined,
                            onError: onError,
                            onSelectRole: function (info, token) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (onSelectRole === null || onSelectRole === void 0 ? void 0 : onSelectRole(token))];
                                        case 1:
                                            _a.sent();
                                            if (useClientRoleInfo) {
                                                dispatch({
                                                    role: info,
                                                });
                                            }
                                            else {
                                                verifyRoleWithServer(token);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                        });
                    }
                    else if (sdk.SDK_TYPE === "GL") {
                        console.warn("[showSelectDialog] Not implemented.");
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        sdkReady,
        gameCode,
        disableAccount,
        disableAccountRoleSelect,
        isAccount,
        useClientRoleInfo,
        onSelectRole,
        dispatch,
        role === null || role === void 0 ? void 0 : role.uid,
    ]);
}
